import { addDays, addMinutes, isBefore, isValid } from 'date-fns';
import { getCurrentMonthlyCycleEndDate } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDataUtils/getCurrentMonthlyCycleEndDate';

interface CalculateEndDateProps {
  durationMinutes: number;
  currentCycleStartDate: Date;
  firstInstanceStartDate: Date;
  refreshPeriodDaysCount: number;
  refreshPeriodMonthsCount: number;
  expirationDate: Date | null;
  isRepeating: boolean;
  isMonthAvailable: boolean;
}

export function calculateEndDate(props: CalculateEndDateProps): Date {
  const {
    durationMinutes,
    currentCycleStartDate,
    firstInstanceStartDate,
    refreshPeriodDaysCount,
    refreshPeriodMonthsCount,
    expirationDate,
    isRepeating,
    isMonthAvailable,
  } = props;

  // For non-repeating credits, the explicit expiration date takes precedence over calculated cycle end dates.
  if (!isRepeating && isValid(expirationDate)) {
    // If LOC expires before it starts, return the first instance start date.
    // Otherwise, return the expiration date.
    return isBefore(expirationDate, firstInstanceStartDate)
      ? firstInstanceStartDate
      : expirationDate;
  }

  if (isMonthAvailable) {
    return getCurrentMonthlyCycleEndDate({
      firstInstanceStartDate,
      durationMinutes,
      currentMonthlyCycleStartDate: currentCycleStartDate,
      refreshPeriodMonthsCount,
    });
  }

  return addMinutes(
    addDays(currentCycleStartDate, refreshPeriodDaysCount - 1),
    durationMinutes
  );
}
